import { render, staticRenderFns } from "./OrdersTable.vue?vue&type=template&id=52a862e1&scoped=true"
import script from "./OrdersTable.vue?vue&type=script&lang=ts"
export * from "./OrdersTable.vue?vue&type=script&lang=ts"
import style0 from "./OrdersTable.vue?vue&type=style&index=0&id=52a862e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a862e1",
  null
  
)

export default component.exports